export enum DermloopLearnReportTypeSubjectEnum {
  LESION_REPORT = 'LESION_REPORT',
  FEATURE_REQUEST_CAPTURE = 'FEATURE_REQUEST_CAPTURE',
  FEATURE_REQUEST_LEARN = 'FEATURE_REQUEST_LEARN',
  FEATURE_REQUEST_DESKTOP = 'FEATURE_REQUEST_DESKTOP',
}
